import { useState, useEffect } from 'react';
import { ScenarioPersona } from '../../api/types/scenario';
import { PersonaListResponse } from '../../api/types';
import { api } from '../../api';
import styles from './ScenarioPersonaSelectionPopUp.module.css';

interface ScenarioPersonaSelectionPopUpProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectPersona: (persona: PersonaListResponse) => void;
  selectedPersona: ScenarioPersona | null;
  defaultPersonaId?: string;
}

function ScenarioPersonaSelectionPopUp({
  isOpen,
  onClose,
  onSelectPersona,
  selectedPersona,
  defaultPersonaId
}: ScenarioPersonaSelectionPopUpProps): JSX.Element | null {
  const [userPersonas, setUserPersonas] = useState<PersonaListResponse[]>([]);
  const [isLoadingPersonas, setIsLoadingPersonas] = useState(false);

  useEffect(() => {
    if (isOpen) {
      loadUserPersonas();
    }
  }, [isOpen]);

  const loadUserPersonas = async () => {
    setIsLoadingPersonas(true);
    try {
      const personas = await api.personas.owned();
      setUserPersonas(personas);
    } catch (error) {
      console.error('Failed to load personas:', error);
    } finally {
      setIsLoadingPersonas(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.personaSelectionModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>Select Your Persona</h3>
          <button className={styles.closeButton} onClick={onClose}>×</button>
        </div>
        
        <div className={styles.personasList}>
          {isLoadingPersonas ? (
            <div className={styles.loadingPersonas}>Loading personas...</div>
          ) : userPersonas.length > 0 ? (
            userPersonas.map((persona) => (
              <div 
                key={persona.id} 
                className={`${styles.personaOption} ${selectedPersona?.id === persona.id ? styles.selectedPersona : ''}`}
                onClick={() => onSelectPersona(persona)}
              >
                <img 
                  src={persona.icon} 
                  alt={persona.display_name} 
                  className={styles.personaOptionAvatar}
                />
                <div className={styles.personaOptionInfo}>
                  <h4 className={styles.personaOptionName}>{persona.display_name}</h4>
                  {selectedPersona?.id === persona.id && (
                    <span className={styles.selectedIndicator}>Selected</span>
                  )}
                  {defaultPersonaId === persona.id && persona.id !== selectedPersona?.id && (
                    <span className={styles.defaultIndicator}>Default</span>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className={styles.noPersonas}>
              <p>You don't have any personas yet.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ScenarioPersonaSelectionPopUp; 